import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { Box } from '@mui/material';
import { AuthState } from 'models/AuthModel';
import auth from 'recoil/atoms/auth';


const AuthLayout = () => {
    const my = useRecoilValue(auth);
    const location = useLocation();

    const from = location.state?.from || '/';

    if (my.state === AuthState.User) {
        return <Navigate to={from} replace />
    }

    return (
        <Box sx={{display: 'flex'}}>
            <Outlet />
        </Box>
    );
};

export default AuthLayout;
